<app-toast [toastModel]="toastViewModel" *ngIf="isShowToast"></app-toast>
<div class="h-100 change_regulatory grid_row">
  <div class="border-right d-flex flex-column py-3 pr-3 grid_part">
    <mat-tab-group class="rig_innertab" [(selectedIndex)]="selectLeftTabIndex"
      (selectedTabChange)="leftTabMenuChanged($event)">
      <mat-tab label="Description">
      </mat-tab>
      <mat-tab label="Document View"></mat-tab>
    </mat-tab-group>
    <app-progress-bar [isLoading]="mappingLoading"></app-progress-bar>
    <div *ngIf="isDescriptionView" class="right_part mt-3">
      <div>
        <div class="card w-100 p-3">
          <div class="d-flex align-items-center justify-content-between w-100 gap-2 flex-wrap mb-3">
            <h3 class="">Description</h3>
            <!-- <lucide-icon size="16" name="square-pen" class="text-blue-lucide cursor-pointer" matTooltip="Edit"
              (click)="editButtonClick()"></lucide-icon> -->
          </div>
          <div *ngFor="let desc of policyMappingDescription" class="d-flex gap-3 align-items-start policyMapping">
            <h4 *ngIf="desc.IsOriginal" class="mb-0">Regulators Description</h4>
            <h4 *ngIf="!desc.IsOriginal" class="mb-0">{{ desc.Jurisdiction }}-{{ desc.User }}</h4>
            <div class="disableText w-100">
              <div *ngIf="desc.Description | hasHtmlTags; else noHtmlTags" [innerHTML]="desc.Description">
              </div>
            </div>
            <ng-template #noHtmlTags>
              <p class="description">{{desc.Description}}</p>
            </ng-template>
            <input type="checkbox" [checked]="desc.isChecked" (change)="addDescription(desc,$event.target.checked)" />
          </div>
        </div>
        <div class="card w-100 p-3 mt-3">
          <h3 class="mb-2">Linked Documents</h3>
          <div *ngFor="let item of linkedDocumentsArray"
            class="d-flex justify-content-between w-100 align-items-start gap-3 my-1">
            <a *ngIf="!isPdfLink(item.link)" href="{{ item.link }}" target="_blank">{{ item.link }} </a>
            <a *ngIf="isPdfLink(item.link)" (click)="openPdf(item.link)">{{ item.link }} </a>
            <input type="checkbox" [checked]="item.isChecked"
              (change)="addLinkedDocuments(item.link,$event.target.checked)" />
          </div>
        </div>
        <div class="card w-100 p-3 mt-3" *ngIf="isShowMappedRegulatory">
          <h3 class="mb-2">Mapped Regulatory Text</h3>
          <div *ngFor="let reg of matchPolicies"
            class="d-flex justify-content-between w-100 align-items-start matchPolicies_div gap-3 my-1">
            <p matTooltip="{{reg.page_content}}" matTooltipPosition="above" matTooltipClass="rig_tooltip">
              {{reg.matchingUpdateDesc}}</p>
            <div class="d-flex gap-1">
              <lucide-icon [matTooltipMultiline]="true" name="info" matTooltipClass="rig_tooltip_info"
                class="text-blue-lucide" style="white-space: pre-wrap; font-family: monospace;"
                [matTooltip]="getTooltipContent(reg.meta_data | policyMetaDataJsonArray:'suggestedName', reg.meta_data | policyMetaDataJsonArray:'Source', reg.meta_data | policyMetaDataJsonArray:'page')">
              </lucide-icon>
              <input type="checkbox" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right_part mt-3" *ngIf="isDocumentView">
      <div class="preview_page h-100" *ngIf="previewVisible">
        <div class="card h-100 position-relative">
          <!-- <i class="pi pi-times cross_btn" aria-hidden="true" (click)="closeCard()"></i> -->
          <div class="card-header" *ngIf="isPdf">
            <nav class="d-flex align-items-center justify-content-center gap-10">
              <!-- *ngIf="isLoaded && isPdf" -->
              <button (click)="prevPage()" [disabled]="page === 1" class="previous btn btn-sm">
                <lucide-icon size="15" name="move-left"></lucide-icon>
              </button>
              <p class="mb-0">{{ page }} / {{ totalPages }}</p>
              <button (click)="nextPage()" [disabled]="page === totalPages" class="next btn btn-sm">
                <lucide-icon size="15" name="move-right"></lucide-icon>
              </button>
              <button class="border-0 p-0 bg-transparent" (click)="zoomIn()"><lucide-icon class="text-blue-lucide"
                  name="zoom-in"></lucide-icon></button>
              <button class="border-0 p-0 bg-transparent" (click)="zoomOut()"><lucide-icon class="text-blue-lucide"
                  name="zoom-out"></lucide-icon></button>
            </nav>
          </div>
          <div class="card-body py-4">
            <pdf-viewer *ngIf="isPdf" [src]="pdfContent" [render-text]="true" [original-size]="false"
              (after-load-complete)="afterLoadComplete($event)" [show-all]="true" [external-link-target]="'blank'"
              [(page)]="page" [zoom]="zoomLevel" [zoom-scale]="'page-width'" (onError)="onPdfError($event)"
              [fit-to-page]="true" [autoresize]="true" [show-toolbar]="true" (onPageChange)="onPageChanged($event)"
              class="content w-100 h-100">
            </pdf-viewer>
            <iframe *ngIf="isTxt" [src]="pdfContent | safe" class="content w-100 h-100"></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="py-3 pl-3">
    <div class="regular_chat card position-relative" [ngClass]="isCollapse ? 'overflow-hidden': ''">
      <div class="regular_chat_card py-4">
        <div class="main-card">
          <div class="chat-header px-4 d-flex align-items-start justify-content-between">
            <div class="docs_tags" *ngIf="!isProcessed">
              <div class="tags d-flex align-items-center gap-2" *ngFor="let item of documentDetail">
                <span (click)="openDocument(item)">{{item.documentName}}</span>
                <button (click)="removeDocument(item)" class="cross-button p-0 border-0 ml-2 bg-transparent">
                  <lucide-icon class="text-primary-lucide" size="18" name="badge-x"></lucide-icon>
                </button>
              </div>
            </div>
            <div class="d-flex docs_tags align-items-center gap-2 flex-wrap" *ngIf="isProcessed">
              <p-skeleton width="12rem" height="2.3rem" borderRadius="16px" />
              <p-skeleton width="10rem" height="2.3rem" borderRadius="16px" />
              <p-skeleton width="18rem" height="2.3rem" borderRadius="16px" />
              <p-skeleton width="32rem" height="2.3rem" borderRadius="16px" />
              <p-skeleton width="12rem" height="2.3rem" borderRadius="16px" />
              <p-skeleton width="10rem" height="2.3rem" borderRadius="16px" />
              <p-skeleton width="18rem" height="2.3rem" borderRadius="16px" />
              <p-skeleton width="32rem" height="2.3rem" borderRadius="16px" />
            </div>
            <div class="btn-group insight-btn-group">
              <button class="border-0 p-0 bg-transparent" (click)="startAttachmentProcess()"
                [disabled]="isProcessingStarted">
                <lucide-icon class="text-blue-lucide mt-2" name="sparkles"></lucide-icon>
              </button>
            </div>
          </div>
          <app-progress-bar [isLoading]="isProgressBar"></app-progress-bar>
          <div class="chat-body px-4">
            <div class="chats" id="rigChatBox">
              <ng-container *ngFor="let message of messages; let i = index">
                <div class="send_messege" [ngClass]="{'reply_messege': message.role == 'assistant'}">
                  <div class="send" [ngClass]="{'reply': message.role == 'assistant'}">
                    <ng-container *ngIf="message.role == 'assistant' && (!isReplyLoading || i !== 0)">
                      <p-avatar image="../../../../assets/images/bot.png" styleClass="mr-2" size="large"
                        shape="circle">
                      </p-avatar>
                      <div class="messege">
                        <markdown class="copymessege text-left d-block" [data]="message.content"
                          [disableSanitizer]="true">
                        </markdown>
                        <div class="typingMessage text-left d-block" *ngIf="isresponseOngoing && i === 0">
                          <div class="typing">
                            <div class="dot"></div>
                            <div class="dot"></div>
                            <div class="dot"></div>
                          </div>
                        </div>
                        <button class="btn-clipboard" matTooltip="Copy to ClipBoard"
                          (click)="copyToClickboard(message.content)" matTooltipPosition="above">
                          <lucide-icon size="16" name="clipboard"></lucide-icon>
                        </button>
                      </div>
                      <lucide-icon class="info-btn" size="17" name="badge-info" *ngIf="message.source.length > 0"
                        [matMenuTriggerFor]="menu"></lucide-icon>
                      <mat-menu #menu="matMenu" class="info_dropdown" xPosition="before">
                        <div class="list p-2">
                          <ul class="p-0 m-0">
                            <li *ngFor="let item of message.source">{{item.Title}} from {{item.PageNo}}</li>
                          </ul>
                        </div>
                      </mat-menu>
                    </ng-container>
                    <ng-container *ngIf="message.role == 'assistant' && isReplyLoading && i === 0">
                      <p-avatar image="../../../../assets/images/bot.png" styleClass="mr-2" size="large"
                        shape="circle">
                      </p-avatar>
                      <div class="messege typingMessage text-left d-block">
                        <div class="typing">
                          <div class="dot"></div>
                          <div class="dot"></div>
                          <div class="dot"></div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="!(message.role == 'assistant')">
                      <div class="messege text-left d-block">
                        <span>{{ message.content }}</span>
                      </div>
                      <p-avatar [image]="null" styleClass="mr-2" size="large" shape="circle">{{message.role ==
                        'assistant' ? '' : (userFirstName.charAt(0) +
                        userLastName.charAt(0)).toUpperCase() }}
                      </p-avatar>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
            </div>
            <div class="suggestion_qustion" [class.customCollapse]="isDownCollapse">
              <div class="question-wrap">
                <button class="cross_btn" (click)="downCollapse()">
                  <span></span>
                </button>
                <div class="question_row">
                  <div class="qustions" *ngFor="let item of suggestedQuestions">
                    <p>{{ item }}</p>
                    <i class="pi pi-send" aria-hidden="true" (click)="sendSuggestedMessage(item)"></i>
                  </div>
                </div>
                <!-- <lucide-icon name="x" class="cross_btn" size="17"></lucide-icon> -->
              </div>
            </div>
          </div>
          <div class="chat-footer px-4">
            <div class="input-group">
              <input type="text" placeholder="Ask Me a Question..." [(ngModel)]="userInput"
                (keyup.enter)="sendMessage()" />
              <button><img src="../../../assets/icons/file.png" (click)="documentDialogue()" /></button>
              <button><img src="../../../assets/icons/link.png" (click)="linkDialogue()" /></button>
              <input type="file" #fileInput style="display: none" (change)="onFileSelected($event)" />
              <label class="custom-upload-button mb-0">
                <img src="../../../assets/icons/clip.png" (click)="openFileInput()" class="clip" alt="Upload File" />
              </label>
              <button [disabled]="documentDetail.length == 0 || userInput.trim() == ''">
                <img src="../../../assets/icons/send.png" (click)="sendMessage()" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="chat_loader">
        <div class="loading-text">
          <span class="loading-text-words">L</span>
          <span class="loading-text-words">O</span>
          <span class="loading-text-words">A</span>
          <span class="loading-text-words">D</span>
          <span class="loading-text-words">I</span>
          <span class="loading-text-words">N</span>
          <span class="loading-text-words">G</span>
          <span class="loading-text-words">.</span>
          <span class="loading-text-words">.</span>
          <span class="loading-text-words">.</span>
        </div>
      </div> -->
    </div>
  </div>
</div>
<!-- dialogue -->
<p-dialog header="Header" class="dialogue_doc" [(visible)]="dialogue" [modal]="true" [style]="{ width: '600px' }"
  [draggable]="false" [resizable]="false">
  <ng-template pTemplate="body">
    <form class="mb-3">
      <ng-container *ngIf="isLinkClicked">
        <div class="d-flex gap-15 align-items-end">
          <div class="form-group flex-1 mb-0">
            <div class="left inline control-label mb-1">Url Link</div>
            <input name="linktxt" class="form-control form-control-sm border-bottom" type="url" id="type"
              [(ngModel)]="hyperText" />
          </div>
          <button class="btn btn-add btn-sm text-white btn-blue text-white" (click)="addHyperLink()">
            <i class="pi pi-plus"></i>
          </button>
        </div>
        <div class="tag_link">
          <div class="tags" *ngFor="let item of hyperLinkList; let i = index">
            <span>{{ item }}</span><i class="pi pi-times" (click)="removeHyperLink(i)"></i>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="isDocTextClicked">
        <div>
          <div class="form-group flex-1 mb-3">
            <div class="left inline control-label mb-1">File Name</div>
            <input name="filename" class="form-control form-control-sm border-bottom" type="text" id="type1"
              [(ngModel)]="docTextName" />
          </div>
          <div class="form-group flex-1 mb-0">
            <div class="left inline control-label mb-1">Text</div>
            <textarea name="filetext" class="form-control form-control-sm border-bottom" type="url" id="type2"
              [(ngModel)]="docText"></textarea>
          </div>
        </div>
      </ng-container>
      <div class="submit_btn text-right mt-4">
        <button class="btn btn-add btn-sm text-white btn-blue text-white" type="button" (click)="createAndUploadFile()"
          *ngIf="!isLoading">
          Submit
        </button>
        <!-- <p-progressSpinner *ngIf="isLoading"></p-progressSpinner> -->
      </div>
    </form>
  </ng-template>
</p-dialog>
<!-- dialogue -->
